import Body from './Body';
import Header from './Header';

const ProductImportItem = {
  Header,
  Body,
};

export default ProductImportItem;
